import React from "react";
import {gql} from "@apollo/client";
import {Query} from "@apollo/client/react/components";
import PropTypes from "prop-types";
import get from "lodash/get";
import universityFragment from "shared/University/fragments/universityFragment";

export const HAS_UNIVERSITY_FEATURE_QUERY = gql`
    query hasUniversityFeatureQuery($universitySlug: String!, $feature: String!) {
        university(slug: $universitySlug) {
            ...UniversityFull
            isFeatureEnabled(feature: $feature)
            isFeatureReadOnly(feature: $feature)
            config {
                features {
                    feature {
                        name
                    }
                    enabledByUnibuddy
                    universityCanToggleFeature
                    enabledByUniversity
                }
            }
        }
    }
    ${universityFragment}
`;

export const HasUniversityFeature = ({universitySlug, feature, children, fallback = null}) => (
    <Query query={HAS_UNIVERSITY_FEATURE_QUERY} variables={{universitySlug, feature}}>
        {({loading, data}) => {
            if (loading) {
                return null;
            }
            if (
                !get(data, "university.isFeatureEnabled", false) &&
                !get(data, "university.isFeatureReadOnly", false)
            ) {
                return fallback;
            }
            return children;
        }}
    </Query>
);

HasUniversityFeature.propTypes = {
    children: PropTypes.node.isRequired,
    universitySlug: PropTypes.string.isRequired,
    feature: PropTypes.string.isRequired,
};
